import gql from 'graphql-tag';

export interface RemoveGuestVar {
  gid: string;
  eventId: number;
}

export interface RemoveGuestResult {
  removeGuest: {
    ok: boolean;
  };
}

export const REMOVE_GUEST = gql`
  mutation RemoveGuest($gid: String!, $eventId: Int!) {
    removeGuest(gid: $gid, eventId: $eventId) {
      ok
    }
  }
`;
